import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Badge, Caption1, Caption1Strong, Menu, MenuDivider, MenuItem, MenuList, MenuPopover, MenuTrigger, makeStyles, Text, tokens, } from '@fluentui/react-components';
import { SignOutRegular } from '@fluentui/react-icons';
import { useAuth } from '#src/auth/AuthProvider.js';
import { useSession } from '#src/auth/session.js';
const useStyles = makeStyles({
    trigger: {
        display: 'flex',
        alignItems: 'center',
        padding: tokens.spacingHorizontalXS,
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: tokens.borderRadiusCircular,
        cursor: 'pointer',
        ':hover': { backgroundColor: tokens.colorSubtleBackgroundHover },
        ':focus-visible': {
            outline: `${tokens.strokeWidthThick} solid ${tokens.colorStrokeFocus2}`,
        },
    },
    popover: { minWidth: '320px', maxWidth: '400px' },
    identity: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalM,
        padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM} ${tokens.spacingVerticalM}`,
    },
    identityText: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXXS,
        minWidth: 0,
    },
    subtle: { color: tokens.colorNeutralForeground3 },
    sectionHeader: {
        display: 'block',
        padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM} ${tokens.spacingVerticalXS}`,
        color: tokens.colorNeutralForeground3,
    },
    roles: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: tokens.spacingHorizontalXS,
        padding: `0 ${tokens.spacingHorizontalM} ${tokens.spacingVerticalS}`,
    },
});
export function UserMenu() {
    const styles = useStyles();
    const { principal } = useSession();
    const { source, signOut } = useAuth();
    const name = principal.kind === 'user' ? principal.name : principal.appId;
    const detail = principal.kind === 'user' ? principal.email : 'Integração (aplicativo)';
    // A cor da marca indica a conta corporativa (Teams); as demais, o modo dev.
    const color = source === 'teams' ? 'brand' : 'colorful';
    return (_jsxs(Menu, { positioning: "below-end", children: [_jsx(MenuTrigger, { disableButtonEnhancement: true, children: _jsx("button", { type: "button", className: styles.trigger, "aria-label": `Conta de ${name}`, children: _jsx(Avatar, { name: name, color: color, size: 28 }) }) }), _jsxs(MenuPopover, { className: styles.popover, children: [_jsxs("div", { className: styles.identity, children: [_jsx(Avatar, { name: name, color: color, size: 40 }), _jsxs("div", { className: styles.identityText, children: [_jsx(Text, { weight: "semibold", truncate: true, wrap: false, children: name }), _jsx(Caption1, { className: styles.subtle, truncate: true, wrap: false, children: detail })] })] }), principal.kind === 'user' && (_jsxs(_Fragment, { children: [_jsx(MenuDivider, {}), _jsx(Caption1Strong, { className: styles.sectionHeader, children: "Perfis" }), _jsx("div", { className: styles.roles, children: principal.roles.length === 0 ? (_jsx(Badge, { appearance: "outline", children: "Sem perfil" })) : (principal.roles.map((role) => (_jsx(Badge, { appearance: "tint", color: "brand", children: role }, role)))) })] })), signOut !== undefined && (_jsxs(_Fragment, { children: [_jsx(MenuDivider, {}), _jsx(Caption1Strong, { className: styles.sectionHeader, children: "Modo de desenvolvimento" }), _jsx(MenuList, { children: _jsx(MenuItem, { icon: _jsx(SignOutRegular, {}), onClick: signOut, children: "Entrar com outro e-mail" }) })] }))] })] }));
}
//# sourceMappingURL=UserMenu.js.map